<res-generic-grid *ngIf="selectedNode" [gridName]="gridName" [automationId]="automationId" [helpIndex]="helpIndex"
    [headerTemplate]="hasHeaderTemplate ? headerTemplate : null"
    [pagerTemplate]="hideDuplicatesVisible ? pagerTemplate : null" [pagerVisible]="pagerVisible"
    [overlayTemplate]="overlayTemplate" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage"
    [isBusyOnInit]="isBusyOnInit" [columnDefs]="columnDefs" [rowSelection]="rowSelection" [rowsHaveGrouping]="true"
    [requestInfo]="requestInfo" [gridContext]="gridContext" [contextMenuOptions]="contextMenuOptions"
    [responseCallback]="responseCallback" [responseArrayCallback]="responseArrayCallback"
    [cellClickedCallback]="cellClickedCallback" [cellDoubleClickedCallback]="cellDoubleClickedCallback"
    [onSelectionChanged]="onSelectionChanged" [loadDataFinishedCallback]="loadDataFinishedCallback"
    [gridPagerCustomCallback]="gridPagerCustomCallback"
    [gridPagerAfterLoadCustomCallback]="gridPagerAfterLoadCustomCallback"
    [onColumnVisibilityChanged]="onColumnVisibilityChanged.bind(this)"
    [onDisplayedColumnsChanged]="onDisplayedColumnsChanged.bind(this)">
</res-generic-grid>
<ng-template #headerTemplate>
    <div class="matrix-generate-doc-list" *ngIf="isMatrixGridSelection">
        <div class="matrix-generation-btn-container">
            <button type="button" [attr.data-automation-id]="automationId + '-generate-document-list-button'"
                class="primary-button" (click)=generateMatrixDocList() onclick="this.blur();">
                <span>Generate Document List</span>
            </button>
            <button type="button" [attr.data-automation-id]="automationId + 'undo-selection-changes-button'"
                class="secondary-button undo-changes-btn" (click)=undoMatrixChanges() onclick="this.blur();">
                <span>Undo Selection Changes</span>
            </button>
        </div>
    </div>
    <button type="button" *ngIf="documentHeaderButtonOptions && !isMatrixGridSelection"
        [attr.data-automation-id]="automationId + '-document-dropdown-button'"
        class="primary-button document-list-dropdown-button"
        [disabled]="!genericGrid || genericGrid.selectedRows.length == 0"
        (click)="onDocumentHeaderButton($event, selectedNode)">
        <i class="fa fa-file-text-o"></i>
        <span>Document</span>
        <i class="fa fa-caret-down"></i>
    </button>
    <span *ngIf="isMatrixTab && !isMatrixGridSelection"
        class="document-list-selected-items">Selected:<span>{{selectedItems()}} /
            {{(totalItemsCount?.toLocaleString())}}</span></span>
    <span *ngIf="documentHeaderButtonOptions && !isMatrixTab"
        class="document-list-selected-items">Selected:<span>{{selectedItems()}}</span><span
            class="hidden-duplicates-label">{{hiddenDuplicatesPresent()}}</span></span>
    <div class="comparison-view-manifest"
        *ngIf="documentHeaderButtonOptions && selectedNode.entityType === 'comparison' && !isMainEmailThreads && !isShortMessageThreads">
        <button type="button" [attr.data-automation-id]="automationId + '-button'" class="secondary-button"
            (click)=createManifest() *ngIf="hasComparisionPermissions">
            <i class="fa fa-list-alt color-blue-01"></i>
            <span>Create Manifest ...</span>
        </button>
    </div>
    <span *ngIf="documentHeaderButtonOptions && selectedNode.entityType === 'exportVolume'"
        class="export-volume-status"> Status: {{getExportVolumeState()}} </span>
    <button type="button" *ngIf="selectedNode.entityType === 'discardPile'"
        [attr.data-automation-id]="automationId + '-discard-pile-log-button'"
        class="secondary-button discard-pile-button" (click)="openDiscardPileLog()">
         <i class="fa fa-history color-blue-01"></i> 
         <i class="fa fa-recycle color-grey-16"></i>        
        <span>Discard Pile Log ...</span>
    </button>    
</ng-template>
<ng-template #pagerTemplate>
    <res-custom-checkbox class="pager-duplicates" [automationId]="automationId + '-hide-duplicates'"
        [(ngModel)]="hideDuplicates" (ngModelChange)="hideDuplicatesChanged()" [content]="hideDuplicatesLabel"
        [marginLeft]="10"></res-custom-checkbox>
    <div class="pager-options-right-align">
        <span *ngIf="selectedNode.entityType === 'searchResult'" class="pager-search">Searched:
            {{searchSize | number}}</span>
        <span *ngIf="selectedNode.entityType === 'searchResult'" class="pager-found">Found:
            {{foundDocumentCount | number}}</span>
    </div>
</ng-template>
<ng-template #overlayTemplate>
    <div class="document-list-generate-button" *ngIf="generateButtonVisible">
        <button type="button" [attr.data-automation-id]="automationId + '-generate-button'" class="primary-button"
            (click)="generateDocumentList()">Generate
            Document List</button>
    </div>
</ng-template>

<res-context-menu #documentHeaderContextMenu>
</res-context-menu>

<div *ngIf="isMatrixGridSelection" class="matrix-selection-overlay"></div>